import { supabaseClient } from "@/lib/supabase";
import type { Template } from "@/types/database/diaries";
import { useQuery } from "@tanstack/react-query";

export const selectTemplates = async () => {
	const { data, error } = await supabaseClient
		.from("templates")
		.select("*, templates_access(*)")
		.order("updated_at", { ascending: false });

	if (error) throw error;

	// Ensure we always return an array
	if (!data) return [];
	return data as Template["Row"][];
};

export const templatesQueryKey = "templates";

export const templateQueryOptions = () => {
	return {
		queryKey: [templatesQueryKey],
		queryFn: selectTemplates,
	};
};

export const useTemplates = () => {
	const result = useQuery(templateQueryOptions());

	// Ensure we always return an array, even if data is undefined or null
	return {
		...result,
		data: result.data ?? [],
	};
};
